// TD Draft 2026-09-28 Q13 — add to cart you can see (Felix 28.09.2026: "ok").
// Loaded by snippets/td-q13-atc-feedback.liquid (main-product section setting td_atc_feedback).
// Scope: only the main product form (id "product-form-main-…") and the D08 sticky bar button, which
// submits the same form. theme.js stays untouched; this file only listens to its events:
//   - aria-busy on the submit buttons (set by ProductForm while /cart/add.js runs) → busy state
//   - variant:add (form) + cart-drawer:refreshed (drawer) → focused 'Hinzugefügt' row in the drawer
//   - cart:error (form) → one error box below the main button that stays until solved
//   - variant:change (form) → error box removed (the buyer changed the selection)
(() => {
  // TD Draft 2026-09-28 Q13 — run once, even if the section is re-rendered in the theme editor
  if (window.tdQ13AtcFeedback) return;
  window.tdQ13AtcFeedback = true;
  // the theme's own error banner is only hidden once this script runs (td-draft-0928-q13.css)
  document.documentElement.classList.add('td-q13-js');

  const FORM_PREFIX = 'product-form-main-';
  const BUSY_CLASS = 'td-q13-busy';
  const BUSY_FALLBACK_MS = 5000; // if neither variant:add nor cart:error arrives after the request
  const PENDING_MAX_MS = 15000;

  const readStrings = () => {
    try {
      return JSON.parse(document.getElementById('td-q13-strings')?.textContent || '{}');
    } catch (error) {
      return {};
    }
  };

  const strings = Object.assign({
    busy: 'Wird hinzugefügt …',
    added: 'Hinzugefügt',
    addedCount: '%%count%% Artikel', // TD Draft 2026-10-03 ADDED-PILLOW — 'Hinzugefügt · 2 Artikel'
    errorTitle: 'Nicht in den Warenkorb gelegt',
    errorFallback: 'Bitte versuchen Sie es noch einmal oder wählen Sie eine andere Ausführung.',
    viewCart: 'Warenkorb ansehen',
    otherVariant: 'Andere Ausführung wählen',
    close: 'Hinweis schließen'
  }, readStrings());

  const reducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  // form.id would return the <input name="id">, so the attribute is read instead
  const isMainForm = (form) => form instanceof HTMLFormElement && (form.getAttribute('id') || '').startsWith(FORM_PREFIX);

  const submitButtons = (form) => Array.from(form.elements).filter((element) => element.type === 'submit');

  const announce = (message) => {
    const target = document.getElementById('status-announcement');
    if (!target) return;
    target.textContent = '';
    requestAnimationFrame(() => { target.textContent = message; });
  };

  const toText = (html) => {
    if (!html) return '';
    return (new DOMParser().parseFromString(String(html), 'text/html').body.textContent || '').trim();
  };

  /* ---------------------------------------------------------------------------------------------
     TD Draft 2026-09-28 Q13 — busy state. The label is laid over the unchanged button text (which
     only turns transparent), so neither the full-width main button nor the sticky button change size.
     --------------------------------------------------------------------------------------------- */
  const busyForms = new Map(); // form → fallback timer id

  const setButtonBusy = (button, on) => {
    if (on) {
      if (button.classList.contains(BUSY_CLASS)) return;
      const overlay = document.createElement('span');
      overlay.className = 'td-q13-busy-label';
      overlay.setAttribute('aria-hidden', 'true');
      const spinner = document.createElement('span');
      spinner.className = 'td-q13-spinner';
      const text = document.createElement('span');
      text.className = 'td-q13-busy-label__text';
      text.textContent = strings.busy;
      overlay.append(spinner, text);
      button.append(overlay);
      button.classList.add(BUSY_CLASS);
    } else {
      button.classList.remove(BUSY_CLASS);
      button.querySelectorAll('.td-q13-busy-label').forEach((node) => node.remove());
    }
  };

  const startBusy = (form) => {
    if (busyForms.has(form)) return;
    busyForms.set(form, 0);
    submitButtons(form).forEach((button) => setButtonBusy(button, true));
    announce(strings.busy);
  };

  const endBusy = (form) => {
    window.clearTimeout(busyForms.get(form));
    busyForms.delete(form);
    submitButtons(form).forEach((button) => setButtonBusy(button, false));
  };

  new MutationObserver((records) => {
    records.forEach((record) => {
      const button = record.target;
      if (!(button instanceof HTMLButtonElement) || button.type !== 'submit' || !isMainForm(button.form)) return;
      const form = button.form;

      if (button.getAttribute('aria-busy') === 'true') {
        startBusy(form);
      } else if (busyForms.has(form) && !busyForms.get(form)) {
        // theme.js clears aria-busy when /cart/add.js answered; the drawer follows after /cart.js.
        // Keep the busy state until variant:add / cart:error, with a fallback for unexpected answers.
        busyForms.set(form, window.setTimeout(() => endBusy(form), BUSY_FALLBACK_MS));
      }
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['aria-busy'] });

  // TD Draft 2026-09-28 Q13 — no double add while 'Wird hinzugefügt …' shows. theme.js drops aria-busy (its
  // own double-submit guard) as soon as /cart/add.js answers, but the drawer still waits for /cart.js;
  // a tap or Enter in that gap would add a second unit. Capture phase on document runs before the
  // ProductForm listener on the form, so the submit never reaches it.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!isMainForm(form) || !busyForms.has(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  /* ---------------------------------------------------------------------------------------------
     TD Draft 2026-09-28 Q13 — errors that stay. One box below the main button (never above it, so
     the button does not move); the sticky bar gets no copy. Removed on the next successful add, on
     a variant change or with ×.
     --------------------------------------------------------------------------------------------- */
  const errorBoxOf = (form) => form.querySelector('.td-q13-error');

  const variantPickerOf = (form) => {
    const scope = form.closest('product-rerender') || document;
    return scope.querySelector('[data-block-type="variant-picker"]');
  };

  // TD Draft 2026-09-28 Q13 — with the Q23 accordion steps the checked input can sit in a collapsed step
  // (visibility: hidden), where focus() silently fails. Take the first target that can really get focus:
  // the checked value if its step is open, otherwise (DOM order) the first step header / visible control.
  const canFocus = (element) => {
    if (!element || !element.getClientRects().length) return false;
    return window.getComputedStyle(element).visibility !== 'hidden';
  };

  const pickerFocusTarget = (picker) => {
    const candidates = [
      picker.querySelector('input:checked:not([disabled])'),
      ...picker.querySelectorAll('button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled])')
    ];
    return candidates.find(canFocus) || null;
  };

  const removeError = (form, restoreFocus) => {
    const box = errorBoxOf(form);
    if (!box) return;
    const hadFocus = box.contains(document.activeElement);
    box.remove();
    if (restoreFocus || hadFocus) {
      form.querySelector('buy-buttons button[type="submit"]')?.focus();
    }
  };

  const buildErrorBox = (form) => {
    const box = document.createElement('div');
    box.className = 'td-q13-error';
    box.setAttribute('role', 'alert');
    box.tabIndex = -1;
    box.innerHTML = `
      <svg class="td-q13-error__icon" aria-hidden="true" focusable="false" width="22" height="22" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="currentColor"/><path d="M12 6.5v7" stroke="#fff" stroke-width="2.2" stroke-linecap="round"/><circle cx="12" cy="17.2" r="1.4" fill="#fff"/></svg>
      <div class="td-q13-error__body">
        <p class="td-q13-error__title"></p>
        <p class="td-q13-error__reason"></p>
        <div class="td-q13-error__actions">
          <button type="button" class="td-q13-error__action" aria-controls="cart-drawer" data-td-q13-view-cart></button>
          <button type="button" class="td-q13-error__action" data-td-q13-other-variant></button>
        </div>
      </div>
      <button type="button" class="td-q13-error__close" data-td-q13-close>
        <svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14"><path d="M1.5 1.5l11 11M12.5 1.5l-11 11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
      </button>`;

    box.querySelector('.td-q13-error__title').textContent = strings.errorTitle;
    box.querySelector('[data-td-q13-view-cart]').textContent = strings.viewCart;
    box.querySelector('[data-td-q13-close]').setAttribute('aria-label', strings.close);

    const otherButton = box.querySelector('[data-td-q13-other-variant]');
    if (variantPickerOf(form)) {
      otherButton.textContent = strings.otherVariant;
      otherButton.addEventListener('click', () => {
        const picker = variantPickerOf(form);
        if (!picker) return;
        picker.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' });
        pickerFocusTarget(picker)?.focus({ preventScroll: true });
      });
    } else {
      otherButton.remove();
    }

    // the theme opens the drawer for every [aria-controls="cart-drawer"] click; the box stays for later
    box.querySelector('[data-td-q13-close]').addEventListener('click', () => removeError(form, true));
    return box;
  };

  const showError = (form, message) => {
    const host = form.querySelector('buy-buttons');
    if (!host) return;

    let box = errorBoxOf(form);
    if (!box) {
      box = buildErrorBox(form);
      host.after(box); // sibling of <buy-buttons>: survives the partial re-render that swaps <buy-buttons>
    }
    box.querySelector('.td-q13-error__reason').textContent = toText(message) || strings.errorFallback;

    // submitted from the sticky bar (main button out of view): bring the box into view and focus it
    const rect = box.getBoundingClientRect();
    const inView = rect.top >= 0 && rect.bottom <= window.innerHeight;
    if (!inView) {
      box.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' });
      box.focus({ preventScroll: true });
    }
  };

  document.addEventListener('cart:error', (event) => {
    const form = event.target;
    if (!isMainForm(form)) return;
    endBusy(form);
    showError(form, event.detail?.error);
  });

  document.addEventListener('variant:change', (event) => {
    const form = event.target;
    if (isMainForm(form)) removeError(form, false);
  });

  /* ---------------------------------------------------------------------------------------------
     TD Draft 2026-09-28 Q13 — 'Hinzugefügt' row. theme.js opens the drawer on cart:change and then
     swaps its content (cart-drawer:refreshed); the row goes in after that swap, above the line
     items (under the free-shipping line), and gets focus once the drawer has finished opening.
     TD Draft 2026-10-03 ADDED-PILLOW — Felix 03.10.2026: "too much space text in drawer when item is added".
     One line instead of a title plus one line per item: 'Hinzugefügt · 135 x 200 cm · 5 kg' for one added
     item, 'Hinzugefügt · 2 Artikel' for several added lines; cut with … rather than wrapping. Product title,
     closure and filling stay in the drawer lines below, which stay marked (td-q13-line-new, a light tint in
     td-draft-0928-q13.css) until the drawer closes.
     --------------------------------------------------------------------------------------------- */
  let pendingAdd = null;

  const countText = (count) => strings.addedCount.replace(/%%count%%|\{\{\s*count\s*\}\}/g, String(count));

  // TD Draft 2026-10-03 ADDED-PILLOW — only size · weight of the one added item ('2 × …' for quantity 2+): no product
  // title, no closure ('Schlaufen') and never the pillow filling ('Ohne (Nur Kissenbezug)').
  // Weight with or without a space ('5 kg', and '2.5kg' of the Gewichtskragen): \bkg\b missed '2.5kg' (no word
  // boundary between '5' and 'k'), so that row showed only 'Hinzugefügt'. The size test stays first ('1 kg (40 x 50 cm)').
  const describeItem = (item, quantity) => {
    const sizes = [];
    const weights = [];

    (item.options_with_values || []).forEach((option) => {
      const value = String(option?.value || '').trim();
      if (!value || value === 'Default Title') return;
      if (/\bcm\b/i.test(value) || /\d\s*[x×]\s*\d/i.test(value)) sizes.push(value);
      else if (/\d\s*kg\b/i.test(value)) weights.push(value);
    });

    const text = [...sizes, ...weights].join(' · ');
    if (quantity > 1) return text ? `${quantity} × ${text}` : countText(quantity);
    return text;
  };

  const markLine = (drawer, item) => {
    const variantId = String(item.variant_id || item.id || '');
    if (!variantId) return;
    drawer.querySelectorAll('line-item').forEach((line) => {
      const link = line.querySelector('a[href*="variant="]');
      if (!link) return;
      const match = link.getAttribute('href').match(/[?&]variant=(\d+)/);
      if (match && match[1] === variantId) line.classList.add('td-q13-line-new');
    });
  };

  const renderAddedRow = (drawer, add) => {
    drawer.querySelectorAll('.td-q13-added').forEach((node) => node.remove());
    const items = add.items.filter(Boolean);
    if (!items.length) return;

    const row = document.createElement('div');
    row.className = 'td-q13-added';
    // TD Draft 2026-09-28 Q13 — no role="status": Prestige already announces the add, the focus reads the row
    row.tabIndex = -1;
    // TD Draft 2026-10-03 ADDED-PILLOW — one line: icon, 'Hinzugefügt' and ' · ' + the details
    row.innerHTML = `
      <svg class="td-q13-added__icon" aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="currentColor"/><path d="M7 12.4l3.2 3.1L17 8.8" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      <p class="td-q13-added__text"><span class="td-q13-added__title"></span></p>`;
    row.querySelector('.td-q13-added__title').textContent = strings.added;

    // TD 2026-10-07 ADDON-QTY — several lines: the pieces of this add (assets/custom.js passes detail.tdUnits = blanket +
    // every add-on unit, e.g. blanket + 2 pillowcases = 3), else the number of lines as before
    const detail = items.length > 1 ? countText(add.units > items.length ? add.units : items.length) : describeItem(items[0], add.quantity);
    if (detail) {
      const variant = document.createElement('span');
      variant.className = 'td-q13-added__variant';
      variant.textContent = ` · ${detail}`;
      row.querySelector('.td-q13-added__text').append(variant);
    }

    const list = drawer.querySelector('.cart-drawer__items');
    if (list) list.before(row);
    else drawer.prepend(row);

    items.forEach((item) => markLine(drawer, item));

    let focused = false;
    const focusRow = () => {
      if (focused || !row.isConnected || !drawer.hasAttribute('open')) return;
      focused = true;
      row.focus({ preventScroll: true });
    };
    drawer.addEventListener('dialog:after-show', focusRow, { once: true });
    window.setTimeout(focusRow, 700); // drawer already open, or no after-show event
    drawer.addEventListener('dialog:after-hide', () => {
      row.remove();
      drawer.querySelectorAll('.td-q13-line-new').forEach((line) => line.classList.remove('td-q13-line-new'));
    }, { once: true });
  };

  document.addEventListener('variant:add', (event) => {
    const form = event.target;
    if (!isMainForm(form)) return;
    endBusy(form);
    removeError(form, false);
    const quantity = parseInt(form.elements.quantity?.value || '1', 10) || 1;
    const units = parseInt(event.detail?.tdUnits, 10) || 0;
    pendingAdd = { items: event.detail?.items || [], quantity, units, at: Date.now() };
  });

  document.addEventListener('cart-drawer:refreshed', (event) => {
    if (!pendingAdd || Date.now() - pendingAdd.at > PENDING_MAX_MS) return;
    const drawer = event.target.closest?.('cart-drawer');
    if (!drawer) return;
    const add = pendingAdd;
    pendingAdd = null;
    renderAddedRow(drawer, add);
  });
})();
